<template>
  <el-dialog
    :visible="visible"
    :append-to-body="true"
    width="390px"
    @close="$emit('update:visible', false)"
    class="c-LotteryConfig"
  >
    <div class="c-LotteryConfigtitle" slot="title">
      <span :style="{ fontSize: '16px', marginRight: '20px' }">
        抽奖配置
      </span>
      <el-button size="mini" @click="addLottery">增加奖项</el-button>
      <el-button size="mini" type="primary" @click="onSubmit">保存配置</el-button>
      <el-button size="mini" @click="$emit('update:visible', false)">取消</el-button>
    </div>
    <div class="container">
      <el-form ref="form" :model="form" size="mini">
        <template v-for="lottery in storeNewLottery">
          <el-form-item :key="lottery.name" :label="lottery.name">
            <el-input v-model="lottery.count" :min="1" placeholder="请输入奖项人数">
              <template #prepend>数量</template>
            </el-input>
            <el-input v-model="lottery.award" placeholder="请输入奖品名称" clearable>
              <template #prepend>奖品</template>
            </el-input>
            <el-input v-model="lottery.num" :min="1" placeholder="请输入每次抽取人数">
              <template #prepend>每次抽取</template>
            </el-input>
            <el-switch v-model="lottery.allIn" active-text="全员抽奖（重复中奖）" inactive-text="仅中一次" />
          </el-form-item>
        </template>
      </el-form>
    </div>

    <el-dialog
      :visible.sync="showAddLottery"
      :append-to-body="true"
      width="300px"
      class="dialog-showAddLottery"
    >
      <div class="add-title" slot="title">增加奖项</div>
      <el-form ref="newLottery" :model="newLottery" size="mini">
        <el-form-item label="奖项名称">
          <el-input v-model="newLottery.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addHandler">增加奖项</el-button>
          <el-button @click="showAddLottery = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>
<script>
import {setData} from '@/helper/index';
import {randomNum} from '@/helper/algorithm';
import {newLotteryField} from "../helper";

export default {
  name: 'LotteryConfig',
  props: {
    visible: Boolean
  },
  computed: {
    storeNewLottery() {
      return this.$store.state.newLottery;
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.form = {
            name: this.$store.state.config.name,
            newLottery: this.$store.state.newLottery
          }
        }
      }
    }
  },
  data() {
    return {
      showAddLottery: false,
      newLottery: { name: '' },
      form: {
        newLottery: []
      }
    };
  },
  methods: {
    onSubmit() {
      const newLottery = this.form.newLottery;
      setData(newLotteryField, newLottery);
      newLottery.forEach(lottery => this.$store.commit('setNewLottery', lottery));
      this.$emit('update:visible', false);

      this.$message({
        message: '保存成功',
        type: 'success'
      });

      this.$nextTick(() => {
        this.$emit('resetconfig');
      });
    },
    addLottery() {
      this.showAddLottery = true;
    },
    randomField() {
      const str = 'abcdefghijklmnopqrstuvwxyz';
      let fieldStr = '';
      for (let index = 0; index < 10; index++) {
        fieldStr += str.split('')[randomNum(1, 27) - 1];
      }
      return `${fieldStr}${Date.now()}`;
    },
    addHandler() {
      const field = this.randomField();
      const data = {
        key: field,
        name: this.newLottery.name,
        count: 1,
        num: 1,
        award: '',
        allIn: false
      };
      this.$store.commit('setNewLottery', data);
      this.newLottery = {
        name: ''
      }
      this.showAddLottery = false;
    }
  }
};
</script>
<style lang="scss">
.c-LotteryConfig {
  .el-dialog__body {
    height: 340px;
    .container {
      height: 100%;
      overflow-y: auto;
      padding: 0 10px;
    }
  }
}
.dialog-showAddLottery {
  .el-dialog {
    height: 186px;
  }
}
</style>
